import {
  view,
  lensPath,
  remove,
  curry,
  and,
  complement,
  equals,
  or,
  identity,
  __,
  gt,
  concat,
  compose,
  ifElse,
  always,
  call,
  is,
  both,
  isNil,
  addIndex,
  map,
} from 'ramda';

export const getIn = curry((keyMap, obj) => view(lensPath(keyMap), obj));
export const removeAtIndex = remove(__, 1);
export const notEqual = complement(equals);
export const nand = complement(and);
export const neither = complement(or);
export const makePlural = curry((str, num) => call(compose(
  concat(str),
  ifElse(identity, always(''), always('s')),
  equals(1),
), num));
export const isValidNumber = both(is(Number), complement(equals(NaN)));

export const isValidObject = both(complement(isNil), is(Object));
export const isNonArrayObject = both(isValidObject, complement(Array.isArray));
export const isValidArray = both(isValidObject, Array.isArray);
export const indexedMap = addIndex(map);



// WEBPACK FOOTER //
// ./src/app/utils/functional.js